import * as React from 'react'

function LoggedUserProfileIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" {...props}>
      <g fill="CurrentColor">
        <path
          data-name="Path 62961"
          d="M7.881 2.343a8.922 8.922 0 00-5.074 1.478A7.659 7.659 0 001.4 5.028v1.685h13.2V5.059a8.585 8.585 0 00-1.5-1.217 9.464 9.464 0 00-5.222-1.5m0-1.4A10.482 10.482 0 0116 4.53v3.583H0V4.53A9.718 9.718 0 017.881.943z"
          transform="translate(10327 616) translate(-10327 -608.113)"
        />
        <path
          data-name="Ellipse 871"
          d="M4 1.4A2.6 2.6 0 106.6 4 2.6 2.6 0 004 1.4M4 0a4 4 0 11-4 4 4 4 0 014-4z"
          transform="translate(10327 616) translate(-10323.19 -616)"
        />
      </g>
    </svg>
  )
}

export default LoggedUserProfileIcon
